import type { Props } from '..'
import type { ReactElement } from 'react'

const KeywordIcon = ({ className, color, onClick, size }: Props): ReactElement => {
  return (
    <svg
      className={className}
      fill="none"
      height={size}
      onClick={onClick}
      role="icon"
      viewBox="0 0 21 21"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill={color} height="21" rx="5" width="21" />
      <path d="M5.5 8.625H15.5" stroke="#E9E9E9" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M5.5 12.375H15.5" stroke="#E9E9E9" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M9.25 4.875L8 16.125" stroke="#E9E9E9" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path
        d="M13 4.875L11.75 16.125"
        stroke="#E9E9E9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default KeywordIcon
